// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'image',
    label: '',
    img: true,
    width: '150'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'name_en',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'navigation_button',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'navigation_type',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'rank',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'url',
    label: '',
    Object: 'value',
    width: '240'
  }, {
    prop: 'online',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'updated_at',
    label: '',
    Object: 'value',
    width: '150'
  }]
}
